import { LightbulbOffIcon } from './LightbulbOffIcon';

/**
 * author: Hans Böhm
 * id 14D09F5A-C467-428B-9C5A-F2B3939D1678
 * name lightbulb-off
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-off.svg
 * tags
 * - Home Automation 
 */
export const BulbOffIcon = LightbulbOffIcon;
export default BulbOffIcon